import React from 'react';
import { Bot } from '../../models/Bots';
import { LinkFavicon } from '../controls/LinkFavicon/LinkFavicon';
import { UIIcon } from '../controls/ui/UIIcon/UIIcon';

interface IBotAppsDisplayProps {
  bot: Bot;
}

export const BotAppsDisplay: React.FC<IBotAppsDisplayProps> = ({ bot }) => {
  return (
    <div className="border-b max-h-[300px] overflow-y-auto cursor-auto">
      {bot.apps.map((app) => {
        return (
          <div className="flex items-center px-3 py-2 gap-2" key={app.id}>
            <div className="iconName">
              {app.appName === 'website' ? (
                <LinkFavicon link={`http://${app.workspaceName!}`} size={20} />
              ) : (
                <UIIcon name={app.appName} type="apps" />
              )}
            </div>
            <span>{app.connectionName || app.appName}</span>
          </div>
        );
      })}
      {bot.apps.length === 0 && (
        <div className="flex items-center px-3 py-2">
          This bot has no connected apps.
        </div>
      )}
    </div>
  );
};
